<template>
  <v-row>
    <v-col>
      <v-text-field
        :id="descFields.headline.id"
        v-model="descFields.headline.value"
        :counter="descFields.headline.maxLength"
        :rules="descFields.headline.rules"
        label="Headline"
        placeholder="Example - Wanted: Numbers wizard!"
        required
        clearable
        height="50"
        class="custom-input pb-3"
        color="secondary"
        append-icon="edit"
        v-trackEvent:focus="{
          event: `opp_${descFields.headline.id}_fill`, props: { action: 'edit' }
        }"
        v-trackEvent:blur="{
          event: `opp_${descFields.headline.id}_fill`, props: { action: 'close_editing' }
        }"
      />
      <HTMLEditor
        class="custom-input"
        label="Description"
        :id="descFields.description.id"
        :editor-options="descriptionEditorOptions"
        :value.sync="descFields.description.value"
        :characters-limit="descFields.description.maxLength"
        :validation-rules="descFields.description.rules"
        v-trackEvent:focus="{
          event: `opp_${descFields.description.id}_fill`, props: { action: 'edit' }
        }"
        v-trackEvent:blur="{
          event: `opp_${descFields.description.id}_fill`, props: { action: 'close_editing' }
        }"
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

import HTMLEditor from '@/components/core/HTMLEditor.vue'
import { IRuleFunction } from '@/types/form'

interface IOpportunityField {
  id: string
  value: string
  minLength: number
  maxLength: number
  rules: IRuleFunction[]
}

@Component({
  components: {
    HTMLEditor
  }
})
export default class Description extends Vue {
  @Prop({ required: true }) descFields: any

  descriptionEditorOptions = {
    placeholder: `For best results please describe:
      1. Your client or project context
      2. The activities or responsibilities for the role
      3. Any deliverables expected"
    `
  }
}
</script>
